import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Importa useLocation y useNavigate
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col,  Tab, Tabs} from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";
import { FloatCardComponent, MisPagosGiraComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import {getGira, cuotasAlumno, getDocumentosGira, getAlumno, updateAlumno, enviarDocumentos, cargarDocumentoApoderado, obtenerDocumentosApoderado, eliminarDocumentoApoderado, descargarDocumentoApoderado, solicitarReembolso, actualizarContactoAdulto} from "../../api/giras.ts";
import {crearReembolso, obtenerReembolsosAlumnoGira, validarPeriodoReembolso} from "../../api/reembolsos.ts";
import {getGeneros, tipoAlimentacion, tipoSangre, tallaPolera} from "../../api/mantenedores.ts";
import {obtenerContactosEmergencia, crearContactoEmergencia, actualizarContactoEmergencia, eliminarContactoEmergencia} from "../../api/contactoEmergencia.api.ts";
import Swal from 'sweetalert2';
import { useAuthStore } from "../../store/auth.store.ts";

export default function MiGiraViewPage() {

    const { t } = useContext(TranslatorContext)
    const navigate = useNavigate();

    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    const [usuario, setUsuario] = useState({});
     const [rut, setRut] = useState("");

    const location = useLocation();


    const [giraData, setGiraData] = useState([]);
    const [cuotas, setCuotas] = useState([]);
    const [idAlumno, setIdAdlumno] = useState(null);
    const [totalGira, setTotalGira] = useState(0);
    const [totalPagado, setTotalPagado] = useState(0);
    const [totalPagadoMultas, setTotalPagadoMultas] = useState(0);
    const [documentos, setDocumentos] = useState([]);
    const [alumnoData, setAlumnoData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [rutInputValue, setRutInputValue] = useState("");
    const [generos, setGeneros] = useState([]);
    const [tipoAlimentacionData, setTipoAlimentacionData] = useState([]);
    const [tipoSangreData, setTipoSangreData] = useState([]);
    const [tallaPoleraData, setTallaPoleraData] = useState([]);
    const [documentosApoderado, setDocumentosApoderado] = useState([]);
    const [nuevoDocumento, setNuevoDocumento] = useState({
        tipo: '',
        archivo: null
    });
    const [idGira, setIdGira] = useState(null);
    const [showReembolsoModal, setShowReembolsoModal] = useState(false);
    const [reembolsoData, setReembolsoData] = useState({
        tipo: 'Fuerza Mayor',
        motivo: '',
        descripcion: '',
        bancoNombre: '',
        tipoCuenta: 'Corriente',
        numeroCuenta: '',
        rutTitular: '',
        emailTitular: '',
        montoSolicitado: ''
    });
    const [reembolsos, setReembolsos] = useState([]);
    const [validacionPeriodo, setValidacionPeriodo] = useState(null);
    const [loadingReembolso, setLoadingReembolso] = useState(false);
    const [showEditContactoModal, setShowEditContactoModal] = useState(false);
    const [editContactoData, setEditContactoData] = useState({
        usuCelular: '',
        idparentesco: ''
    });
    const [contactosEmergencia, setContactosEmergencia] = useState([]);
    const [showContactoEmergenciaModal, setShowContactoEmergenciaModal] = useState(false);
    const [showEditContactoEmergenciaModal, setShowEditContactoEmergenciaModal] = useState(false);
    const [contactoEmergenciaData, setContactoEmergenciaData] = useState({
        cem_rut: '',
        cem_nombres: '',
        cem_apellidos: '',
        cem_email: '',
        cem_celular: '',
        cem_parentesco: ''
    });
    const [editContactoEmergenciaData, setEditContactoEmergenciaData] = useState({
        cem_rut: '',
        cem_nombres: '',
        cem_apellidos: '',
        cem_email: '',
        cem_celular: '',
        cem_parentesco: ''
    });
    const [selectedContactoEmergenciaId, setSelectedContactoEmergenciaId] = useState(null);

    const tiposDocumentos = [
        { id: 'permiso_notarial', nombre: 'Permiso Notarial' },
        { id: 'documento_viaje', nombre: 'Documento de Viaje (Carnet o Pasaporte)' },
        { id: 'receta_medica', nombre: 'Receta Médica o Certificado Médico' }
    ];


     const floats = [
        { "title": "total por pagar", "digit": "$"+totalGira?.toLocaleString('es-CL'), "icon": "shopping_cart", "variant": "sm pink" }, 
        { "title": "pendiente de pago", "digit": "$"+(totalGira - totalPagado)?.toLocaleString('es-CL'), "icon": "hotel_class", "variant": "sm blue" },
        { "title": "pagado (Multas pagas: $"+totalPagadoMultas?.toLocaleString('es-CL')+")", "digit": "$"+totalPagado?.toLocaleString('es-CL'), "icon": "shopping_bag", "variant": "sm orange" },

    ]

    useEffect(() => {

                     setUsuario(useAuthStore.getState().usuario);
                     const rut = useAuthStore.getState().usuario.rut;
                     setRut(rut.toLocaleString('es-ES')+'-'+useAuthStore.getState().usuario.dv);

                    const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
                    const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
                    const alumnoId = params.get('alumno'); // Obtén el valor del parámetro 'alumno'
                    setIdAdlumno(alumnoId);
                    setIdGira(giraId);        
                    
                    const fetchTabla = async () => {
                      
                        const res = await getGira(giraId);
                      
                        setGiraData(res.gira);

                        const restCuotas = await cuotasAlumno(alumnoId);
                       
                        const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
                        setTotalGira(sumaTotalCuotas);

                        const totalPagado = restCuotas
                            .filter(cuota => cuota.cou_montopagado !== null)
                            .reduce((total, cuota) => total + (Number(cuota.cou_montopagado || 0) - Number(cuota.cou_multa || 0)), 0);
                        // Puedes guardar el total pagado en un estado si lo necesitas:
                        setTotalPagado(totalPagado);

                        const totalPagadoMultas = restCuotas
                            .filter(cuota => cuota.cou_montopagado !== null)
                            .reduce((total, cuota) => total + Number(cuota.cou_multa || 0), 0);
                        // Puedes guardar el total pagado en un estado si lo necesitas:
                        setTotalPagadoMultas(totalPagadoMultas);

                        setCuotas(restCuotas);

                        const resDocumentos = await getDocumentosGira(giraId);
                        setDocumentos(resDocumentos);

                        const restAlumno = await getAlumno(alumnoId);
                        setAlumnoData(restAlumno);

                        // Cargar contactos de emergencia
                        const contactosResult = await obtenerContactosEmergencia(alumnoId);
                        if (!contactosResult.error) {
                            setContactosEmergencia(contactosResult.data || []);
                        }

                        const generosData = await getGeneros();
                        setGeneros(generosData.data);
                        console.log("generosData", generos);

                        const tipoAlimentacionData = await tipoAlimentacion();
                        setTipoAlimentacionData(tipoAlimentacionData.data);

                        const tipoSangreData = await tipoSangre();
                        setTipoSangreData(tipoSangreData.data);

                        const tallaPoleraData = await tallaPolera();
                        setTallaPoleraData(tallaPoleraData.data);

                    }
        
                    
                    fetchTabla();   
                   
                }, []);

    // useEffect para cargar documentos del apoderado
    useEffect(() => {
      if (idAlumno && idGira) {
        obtenerDocumentosApoderado(idAlumno, idGira).then((docs) => {
          if (!docs.error && Array.isArray(docs)) {
            setDocumentosApoderado(docs);
          }
        }).catch((error) => {
          console.error('Error al cargar documentos del apoderado:', error);
        });
      }
    }, [idAlumno, idGira]);

    // useEffect para cargar reembolsos existentes
    useEffect(() => {
      if (idAlumno && idGira) {
        obtenerReembolsosAlumnoGira(idAlumno, idGira).then((res) => {
          if (!res.error) {
            setReembolsos(res.reembolsos || []);
          }
        }).catch((error) => {
          console.error('Error al cargar reembolsos:', error);
        });
      }
    }, [idAlumno, idGira]);

    // Función para verificar si la fecha actual es anterior a la fecha límite de edición
    const isEditButtonVisible = () => {
        if (!giraData?.gir_fechalimiteedicion) return true; // Si no hay fecha límite, mostrar el botón
        
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const [year, month, day] = giraData.gir_fechalimiteedicion.split('-');
        const limitDate = new Date(year, month - 1, day);
        
        return today < limitDate; // Mostrar botón solo si hoy es antes de la fecha límite
    };

    // Función para convertir fecha de DD/MM/YYYY a YYYY-MM-DD
    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        
        // Si ya está en formato YYYY-MM-DD, devolverla tal como está
        if (dateString.includes('-')) return dateString;
        
        // Convertir de DD/MM/YYYY a YYYY-MM-DD
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Función para convertir fecha de YYYY-MM-DD a DD/MM/YYYY
    const formatDateForSave = (dateString) => {
        if (!dateString) return "";
        
        // Si ya está en formato DD/MM/YYYY, devolverla tal como está
        if (dateString.includes('/')) return dateString;
        
        // Convertir de YYYY-MM-DD a DD/MM/YYYY
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    // Función para formatear y validar RUT
    const checkRut = (rutInput) => {
        // Despejar Puntos
        var valor = rutInput.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
        
        // Aislar Cuerpo y Dígito Verificador
        const cuerpo = valor.slice(0,-1);
        const dv = valor.slice(-1).toUpperCase();
        
        // Formatear RUN
        rutInput.value = cuerpo + '-'+ dv;
        
        // Si no cumple con el mínimo ej. (n.nnn.nnn)
        if(cuerpo.length < 7) { 
            rutInput.setCustomValidity("RUT Incompleto"); 
            return false;
        }
        
        // Calcular Dígito Verificador
        let suma = 0;
        let multiplo = 2;
        
        // Para cada dígito del Cuerpo
        for(let i=1; i<=cuerpo.length; i++) {
            // Obtener su Producto con el Múltiplo Correspondiente
            const index = multiplo * valor.charAt(cuerpo.length - i);
            
            // Sumar al Contador General
            suma = suma + index;
            
            // Consolidar Múltiplo dentro del rango [2,7]
            if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
        }
        
        // Calcular Dígito Verificador en base al Módulo 11
        let dvEsperado = 11 - (suma % 11);
        
        // Casos Especiales (0 y K)
        let dvNumerico = (dv === 'K') ? 10 : parseInt(dv);
        dvNumerico = (dvNumerico === 0) ? 11 : dvNumerico;
        
        // Validar que el Cuerpo coincide con su Dígito Verificador
        if(dvEsperado !== dvNumerico) { 
            rutInput.setCustomValidity("RUT Inválido"); 
            return false; 
        }
        
        // Si todo sale bien, eliminar errores (decretar que es válido)
        rutInput.setCustomValidity('');
        
        // Actualizar el estado
        setEditData({ 
            ...editData, 
            alu_rut: parseInt(cuerpo), 
            alu_dv: dv 
        });
        
        // Actualizar el valor del input
        setRutInputValue(rutInput.value);
        
        return true;
    };

    const handleOpenEditModal = () => {
        setEditData({
            ...alumnoData,
            alu_fecha_vencimiento_documento: alumnoData?.alu_fecha_vencimiento_documento 
                ? formatDateForInput(alumnoData.alu_fecha_vencimiento_documento) 
                : ""
        });
        setRutInputValue(alumnoData?.alu_rut ? (alumnoData?.alu_dv ? `${alumnoData.alu_rut}-${alumnoData.alu_dv}` : `${alumnoData.alu_rut}`) : "");
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => setShowEditModal(false);

    const handleOpenEditContactoModal = () => {
        setEditContactoData({
            usuCelular: alumnoData?.celularcontacto || '',
            idparentesco: alumnoData?.idparentesco || ''
        });
        setShowEditContactoModal(true);
    };

    const handleCloseEditContactoModal = () => setShowEditContactoModal(false);

    const handleEditContactoChange = (e) => {
        const { name, value } = e.target;
        setEditContactoData({ ...editContactoData, [name]: value });
    };

    const handleSaveEditContacto = async () => {
        if (!editContactoData.usuCelular || !editContactoData.idparentesco) {
            Swal.fire({
                icon: 'warning',
                text: 'Debes completar todos los campos'
            });
            return;
        }

        Swal.fire({
            title: 'Guardando cambios...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const resultado = await actualizarContactoAdulto(
            idAlumno,
            editContactoData.usuCelular,
            editContactoData.idparentesco
        );

        Swal.close();

        if (resultado.error === false) {
            // Actualizar alumnoData con los nuevos valores
            const restAlumno = await getAlumno(idAlumno);
            setAlumnoData(restAlumno);
            setShowEditContactoModal(false);
            
            Swal.fire({
                icon: 'success',
                text: 'Contacto adulto responsable actualizado correctamente'
            });
        } else {
            Swal.fire({
                icon: 'error',
                text: resultado.msg || 'Error al actualizar el contacto'
            });
        }
    };

    // Funciones para Contacto de Emergencia
    const cargarContactosEmergencia = async () => {
        const resultado = await obtenerContactosEmergencia(idAlumno);
        if (!resultado.error) {
            setContactosEmergencia(resultado.data || []);
        }
    };

    const handleOpenContactoEmergenciaModal = () => {
        setContactoEmergenciaData({
            cem_rut: '',
            cem_nombres: '',
            cem_apellidos: '',
            cem_email: '',
            cem_celular: '',
            cem_parentesco: ''
        });
        setShowContactoEmergenciaModal(true);
    };

    const handleCloseContactoEmergenciaModal = () => {
        setShowContactoEmergenciaModal(false);
    };

    const handleContactoEmergenciaChange = (e) => {
        const { name, value } = e.target;
        setContactoEmergenciaData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSaveContactoEmergencia = async () => {
        // Validaciones
        if (!contactoEmergenciaData.cem_rut || !contactoEmergenciaData.cem_nombres || 
            !contactoEmergenciaData.cem_apellidos || !contactoEmergenciaData.cem_email || 
            !contactoEmergenciaData.cem_celular || !contactoEmergenciaData.cem_parentesco) {
            Swal.fire({
                icon: 'warning',
                text: 'Todos los campos son obligatorios'
            });
            return;
        }

        Swal.fire({
            title: 'Guardando contacto...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const resultado = await crearContactoEmergencia({
            aluId: idAlumno,
            ...contactoEmergenciaData
        });

        Swal.close();

        if (resultado.error === false) {
            await cargarContactosEmergencia();
            setShowContactoEmergenciaModal(false);
            Swal.fire({
                icon: 'success',
                text: 'Contacto de emergencia creado exitosamente'
            });
        } else {
            Swal.fire({
                icon: 'error',
                text: resultado.message || 'Error al crear el contacto'
            });
        }
    };

    const handleOpenEditContactoEmergenciaModal = (contacto) => {
        setSelectedContactoEmergenciaId(contacto.cem_id);
        setEditContactoEmergenciaData({
            cem_rut: contacto.cem_rut,
            cem_nombres: contacto.cem_nombres,
            cem_apellidos: contacto.cem_apellidos,
            cem_email: contacto.cem_email,
            cem_celular: contacto.cem_celular,
            cem_parentesco: contacto.cem_parentesco
        });
        setShowEditContactoEmergenciaModal(true);
    };

    const handleCloseEditContactoEmergenciaModal = () => {
        setShowEditContactoEmergenciaModal(false);
        setSelectedContactoEmergenciaId(null);
    };

    const handleEditContactoEmergenciaChange = (e) => {
        const { name, value } = e.target;
        setEditContactoEmergenciaData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSaveEditContactoEmergencia = async () => {
        // Validaciones
        if (!editContactoEmergenciaData.cem_rut || !editContactoEmergenciaData.cem_nombres || 
            !editContactoEmergenciaData.cem_apellidos || !editContactoEmergenciaData.cem_email || 
            !editContactoEmergenciaData.cem_celular || !editContactoEmergenciaData.cem_parentesco) {
            Swal.fire({
                icon: 'warning',
                text: 'Todos los campos son obligatorios'
            });
            return;
        }

        Swal.fire({
            title: 'Guardando cambios...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const resultado = await actualizarContactoEmergencia(selectedContactoEmergenciaId, editContactoEmergenciaData);

        Swal.close();

        if (resultado.error === false) {
            await cargarContactosEmergencia();
            setShowEditContactoEmergenciaModal(false);
            Swal.fire({
                icon: 'success',
                text: 'Contacto de emergencia actualizado exitosamente'
            });
        } else {
            Swal.fire({
                icon: 'error',
                text: resultado.message || 'Error al actualizar el contacto'
            });
        }
    };

    const handleDeleteContactoEmergencia = async (cemId) => {
        Swal.fire({
            title: '¿Eliminar contacto?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const resultado = await eliminarContactoEmergencia(cemId);
                if (resultado.error === false) {
                    await cargarContactosEmergencia();
                    Swal.fire({
                        icon: 'success',
                        text: 'Contacto de emergencia eliminado exitosamente'
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        text: resultado.message || 'Error al eliminar el contacto'
                    });
                }
            }
        });
    };

    const handleDocumentoTipoChange = (e) => {
        setNuevoDocumento({ ...nuevoDocumento, tipo: e.target.value });
    };

    const handleDocumentoArchivoChange = (e) => {
        const file = e.target.files[0];
        setNuevoDocumento({ ...nuevoDocumento, archivo: file });
    };

    const handleCargarDocumento = async () => {
        if (!nuevoDocumento.tipo) {
            Swal.fire({
                icon: 'warning',
                text: 'Por favor selecciona el tipo de documento'
            });
            return;
        }

        if (!nuevoDocumento.archivo) {
            Swal.fire({
                icon: 'warning',
                text: 'Por favor selecciona un archivo'
            });
            return;
        }

        if (documentosApoderado.length >= 10) {
            Swal.fire({
                icon: 'warning',
                text: 'No puedes cargar más de 10 documentos'
            });
            return;
        }

        // Validar que tenga idAlumno e idGira
        if (!idAlumno || !idGira) {
            Swal.fire({
                icon: 'error',
                text: 'No se pudo obtener la información necesaria para cargar el documento'
            });
            return;
        }

        // Mostrar loading
        Swal.fire({
            title: 'Cargando documento...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Enviar archivo a la API
        const resultado = await cargarDocumentoApoderado(idAlumno, idGira, nuevoDocumento.tipo, nuevoDocumento.archivo);

        Swal.close();

        if (resultado.error) {
            Swal.fire({
                icon: 'error',
                text: resultado.msg || 'Error al cargar el documento'
            });
            return;
        }

        // Agregar a la lista local
        const nuevoDocumentoObj = {
            doc_id: resultado.doc_id || Date.now(),
            alu_id: idAlumno,
            gir_id: idGira,
            doc_tipo: nuevoDocumento.tipo,
            doc_nombre: nuevoDocumento.archivo.name,
            file_path: resultado.filePath,
            created_at: new Date().toLocaleString()
        };

        setDocumentosApoderado([...documentosApoderado, nuevoDocumentoObj]);
        setNuevoDocumento({ tipo: '', archivo: null });
        
        Swal.fire({
            icon: 'success',
            text: 'Documento cargado correctamente'
        });
    };

    const handleEliminarDocumento = async (documentoId) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Eliminar de la BD si tiene doc_id
                const doc = documentosApoderado.find(d => d.doc_id === documentoId || d.id === documentoId);
                if (doc && doc.doc_id) {
                    Swal.fire({
                        title: 'Eliminando...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const resultado = await eliminarDocumentoApoderado(doc.doc_id);
                    Swal.close();
                    
                    if (resultado.error) {
                        Swal.fire({
                            icon: 'error',
                            text: resultado.msg || 'Error al eliminar documento'
                        });
                        return;
                    }
                }
                
                // Eliminar del estado local
                setDocumentosApoderado(documentosApoderado.filter(d => d.doc_id !== documentoId && d.id !== documentoId));
                Swal.fire({
                    icon: 'success',
                    text: 'Documento eliminado exitosamente'
                });
            }
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        if (name === "alu_nombre_social_activo" && value === "0") {
            // Si selecciona "No", limpiar el campo de Nombre Social
            setEditData({ ...editData, [name]: value, alu_nombre_social: "" });
        } else {
            setEditData({ ...editData, [name]: value });
        }
    };

    const handleSaveEdit = async () => {
        const camposRequeridos = [
        { key: "alu_nombres", label: "Nombres" },
        { key: "alu_apellidos", label: "Apellidos" },
        { key: "alu_rut", label: "RUT" },
        { key: "alu_fnacimiento", label: "Fecha de Nacimiento" },
        { key: "alu_nacionalidad", label: "Nacionalidad" },
        { key: "idgenero", label: "Género" },
        { key: "idalimentacion", label: "Tipo Alimentación" },
        { key: "idsangre", label: "Tipo Sangre" },
        { key: "idpolera", label: "Talla Polera" },
        { key: "alu_alergia", label: "Alergía" },
        { key: "alu_enfermedad", label: "Enfermedad Preexistente" },
        { key: "alu_tratamiento", label: "Tratamiento" },
        { key: "alu_tipo_documento", label: "Tipo de Documento para Viaje" },
        { key: "alu_fecha_vencimiento_documento", label: "Fecha de Vencimiento del Documento" },
        ...(editData.alu_nombre_social_activo === "1" ? [{ key: "alu_nombre_social", label: "Nombre Social" }] : [])
    ];

    // Busca campos vacíos
    const vacios = camposRequeridos.filter(campo => !editData[campo.key] || editData[campo.key].toString().trim() === "");

    if (vacios.length > 0) {
        Swal.fire({
            icon: 'warning',
            text: `Debes completar: ${vacios.map(v => v.label).join(', ')}`
        });
        return;
    }

    
        // Aquí deberías llamar a tu API para guardar los cambios
         updateAlumno(editData).then(async res => {
                       Swal.close();
                    //  fetchTabla();
                       if (res.error === false) {
                          const restAlumno = await getAlumno(editData.alu_id);
                          setAlumnoData(restAlumno);
                           setShowEditModal(false);
                             
                         Swal.fire({
                           icon: 'success',
                           text: 'Alumno editada correctamente.'
                         })
                         
                       }
                       else {
                         let errorMsg = res.msg;
                         if (res.errores) {
                           errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
                           res.errores.forEach(error => {
                             errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
                           });
                           errorMsg += '</tbody></table>';
                         }
             
                         Swal.fire({
                           icon: 'error',
                         
                           html: errorMsg
                         })
                       }
             
                     });
        console.log("Datos editados:", editData);
        //setAlumnoData(editData); // Actualiza el estado local
       
    };

    const handleOpenReembolsoModal = async () => {
        setLoadingReembolso(true);
        // Validar período de reembolso
        if (idGira) {
            const validacion = await validarPeriodoReembolso(idGira);
            setValidacionPeriodo(validacion);
            
            // Solo mostrar error si tiene validación de fecha y está fuera del período
            if (validacion.tieneValidacion && !validacion.esValido) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Período de Reembolso Vencido',
                    html: `<div style="text-align: left;">
                        <p><strong>Solo se aceptan solicitudes en el siguiente período:</strong></p>
                        <ul>
                            <li>Desde la firma del contrato</li>
                            <li>Hasta 72 horas antes de la salida del viaje${validacion.gir_fviaje ? ` (${validacion.gir_fviaje})` : ''}</li>
                            <li>Antes del 30 de octubre del año del viaje</li>
                        </ul>
                        <p><strong>Tu solicitud está fuera de este período.</strong></p>
                    </div>`,
                    confirmButtonText: 'Entendido'
                });
                setLoadingReembolso(false);
                return;
            }
        }
        
        // Cargar reembolsos existentes
        if (idAlumno && idGira) {
            const res = await obtenerReembolsosAlumnoGira(idAlumno, idGira);
            if (!res.error) {
                setReembolsos(res.reembolsos || []);
            }
        }
        
        setLoadingReembolso(false);
        setShowReembolsoModal(true);
    };
    
    const handleCloseReembolsoModal = () => {
        setShowReembolsoModal(false);
        setReembolsoData({
            tipo: 'Fuerza Mayor',
            motivo: '',
            descripcion: '',
            bancoNombre: '',
            tipoCuenta: 'Corriente',
            numeroCuenta: '',
            rutTitular: '',
            emailTitular: '',
            montoSolicitado: ''
        });
        setValidacionPeriodo(null);
    };

    const handleReembolsoChange = (e) => {
        const { name, value } = e.target;
        setReembolsoData({
            ...reembolsoData,
            [name]: value
        });
    };

    const handleSolicitarReembolso = async () => {
        // Validar campos requeridos
        if (!reembolsoData.tipo || !reembolsoData.motivo || !reembolsoData.bancoNombre || 
            !reembolsoData.tipoCuenta || !reembolsoData.numeroCuenta || !reembolsoData.rutTitular || 
            !reembolsoData.emailTitular || !reembolsoData.montoSolicitado) {
            Swal.fire({
                icon: 'warning',
                text: 'Todos los campos marcados con * son requeridos'
            });
            return;
        }

        Swal.fire({
            title: 'Procesando...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        const data = {
            alumnoId: idAlumno,
            giraId: idGira,
            tipo: reembolsoData.tipo,
            motivo: reembolsoData.motivo,
            descripcion: reembolsoData.descripcion,
            bancoNombre: reembolsoData.bancoNombre,
            tipoCuenta: reembolsoData.tipoCuenta,
            numeroCuenta: reembolsoData.numeroCuenta,
            rutTitular: reembolsoData.rutTitular,
            emailTitular: reembolsoData.emailTitular,
            montoSolicitado: parseFloat(reembolsoData.montoSolicitado),
            anioGira: giraData.gir_anio || new Date().getFullYear()
        };

        const res = await crearReembolso(data);
        Swal.close();

        if (res.error === false) {
            Swal.fire({
                icon: 'success',
                title: 'Solicitud Registrada',
                text: res.valido 
                    ? 'Tu solicitud de reembolso ha sido registrada correctamente. Será validada por la empresa.'
                    : 'Advertencia: Tu solicitud está fuera del período elegible, pero ha sido registrada para revisión.'
            });
            handleCloseReembolsoModal();
            // Recargar reembolsos
            if (idAlumno && idGira) {
                const reloadRes = await obtenerReembolsosAlumnoGira(idAlumno, idGira);
                if (!reloadRes.error) {
                    setReembolsos(reloadRes.reembolsos || []);
                }
            }
        } else {
            Swal.fire({
                icon: 'error',
                text: res.msg || 'Error al crear solicitud de reembolso'
            });
        }
    };
            
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Detalle Reserva</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Cristour</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Gira de estudios</Link></li>
                                <li className="mc-breadcrumb-item">Detalle Reserva</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col xl={12}>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button type='button' className='btn btn-primary' onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className='material-icons'>arrow_back</i>
                            <span>Volver </span>
                        </button>
                       
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN DE GRUPO */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Información de grupo</h4>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Grupo</strong>
                                        <p>{giraData.est_nombre}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Destino</strong>
                                        <p>{giraData.com_nombre}, {giraData.reg_nombre}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Programa</strong>
                                        <p>{giraData.programa}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Tramo</strong>
                                        <p>{giraData.tramo}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Inicio Viaje</strong>
                                        <p>{giraData.gir_fviaje || 'No definida'}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Término Viaje</strong>
                                        <p>{giraData.gir_fterminoviaje || 'No definida'}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Liberados</strong>
                                        <p>{giraData.gir_liberados}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Valor</strong>
                                        <p>${totalGira?.toLocaleString('es-CL')}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                {giraData.gir_coordinador && (
                                    <Col md={3}>
                                        <div>
                                            <strong>Coordinador</strong>
                                            <p>{giraData.gir_coordinador}</p>
                                        </div>
                                    </Col>
                                )}
                                {giraData.gir_gestor && (
                                    <Col md={3}>
                                        <div>
                                            <strong>Gestor</strong>
                                            <p>{giraData.gir_gestor}</p>
                                        </div>
                                    </Col>
                                )}
                                {giraData.gir_tipo_transporte && (
                                    <Col md={3}>
                                        <div>
                                            <strong>Tipo de Transporte</strong>
                                            <p>{giraData.gir_tipo_transporte}</p>
                                        </div>
                                    </Col>
                                )}
                                {giraData.gir_hotel && (
                                    <Col md={3}>
                                        <div>
                                            <strong>Hotel</strong>
                                            <p>{giraData.gir_hotel}</p>
                                        </div>
                                    </Col>
                                )}
                            </Row>

                        

                            {(giraData.gir_traslado === true || giraData.gir_traslado === 1) && (
                                <Row className="mb-3">
                                    {giraData.gir_punto_encuentro && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Punto de Encuentro</strong>
                                                <p>{giraData.gir_punto_encuentro}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {giraData.gir_horario_encuentro && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Horario de Encuentro</strong>
                                                <p>{giraData.gir_horario_encuentro}</p>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                            )}

                            {giraData.gir_voucher_seguro && (
                                <Row>
                                    <Col md={3}>
                                        <div>
                                            <strong>Nº Voucher Seguro Médico</strong>
                                            <p>{giraData.gir_voucher_seguro}</p>
                                        </div>
                                    </Col>
                                </Row>
                            )}

                              {(giraData.gir_fecha_reunion_presalida || giraData.gir_modalidad_reunion) && (
                                                                <Row className="mb-3" style={{ borderTop: '1px solid #e1bee7', paddingTop: '15px' }}>
                                                                    {giraData.gir_fecha_reunion_presalida && (
                                                                        <Col md={3}>
                                                                            <div>
                                                                                <strong>Reunión Pre-Salida</strong>
                                                                                <p>{new Date(giraData.gir_fecha_reunion_presalida).toLocaleString('es-CL')}</p>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {giraData.gir_modalidad_reunion && (
                                                                        <Col md={3}>
                                                                            <div>
                                                                                <strong>Modalidad Reunión</strong>
                                                                                <p style={{ textTransform: 'capitalize', fontWeight: '500', color: giraData.gir_modalidad_reunion === 'virtual' ? '#1976d2' : '#43a047' }}>
                                                                                    {giraData.gir_modalidad_reunion === 'virtual' ? '🌐 Virtual' : '📍 Presencial'}
                                                                                </p>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* DATOS PASAJERO */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#e8f5e9' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #c8e6c9' }}>
                            <h6 style={{ margin: 0, color: '#2e7d32', fontWeight: 'bold' }}>Datos pasajero, OBLIGATORIOS A REVISAR Y COMPLETAR</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={2}>
                                    <div>
                                        <strong>RUT</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_rut ? `${alumnoData.alu_rut}-${alumnoData.alu_dv}` : ""} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div>
                                        <strong>Tipo de Pasajero</strong>
                                        <Form.Control type="text" value={alumnoData?.calidad || ""} readOnly size="sm" />
                                    </div>
                                </Col>
                               
                                <Col md={2}>
                                    <div>
                                        <strong>Nacionalidad</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_nacionalidad || ""} readOnly size="sm" />
                                       
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div>
                                        <strong>Apellidos</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_apellidos || ""} readOnly size="sm" />
                                    </div>
                                </Col>
                                 <Col md={3}>
                                    <div>
                                        <strong>Nombres</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_nombres || ""} readOnly size="sm" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                               
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha de nacimiento</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_fnacimiento || ""} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Género CI</strong>
                                        <Form.Select size="sm" value={alumnoData?.idgenero || ""}>
                                            <option>{alumnoData?.genero || "Seleccionar"}</option>
                                        </Form.Select>
                                    </div>
                                </Col>
                                  <Col md={3}>
                                    <div>
                                        <strong>Nombre Social</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_nombre_social_activo === 1 ? (alumnoData?.alu_nombre_social || "No registrado") : "-"} readOnly size="sm" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Tipo de Documento para Viaje</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_tipo_documento || ""} readOnly size="sm" placeholder="No registrado" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha de Vencimiento Documento</strong>
                                        <Form.Control type="text" value={alumnoData?.alu_fecha_vencimiento_documento || ""} readOnly size="sm" placeholder="No registrado" />
                                    </div>
                                </Col>
                            </Row>
                            
                            {isEditButtonVisible() && (
                                <div style={{ marginTop: '15px' }}>
                                    <button type='button' onClick={handleOpenEditModal} className='btn btn-warning btn-sm'>
                                        <i className='material-icons' style={{ marginRight: '5px' }}>edit</i>
                                        Editar Datos del Pasajero
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* FICHA MÉDICA */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#fffde7' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #fff9c4' }}>
                            <h6 style={{ margin: 0, color: '#f57f17', fontWeight: 'bold' }}>Ficha Médica</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Tipo Alimentación</strong>
                                        <Form.Control type="text" value={alumnoData?.alimientacion || "Sin restricción"} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Grupo sanguíneo</strong>
                                        <Form.Control type="text" value={alumnoData?.sangre || "Sin información"} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Enfermedad Pre-existente y/o Tipo de Alergia </strong>
                                        <Form.Control as="textarea" rows={2} value={alumnoData?.alu_enfermedad || "NO"} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Tratamiento <span style={{ fontSize: '0.8rem' }}>Cual/No</span></strong>
                                        <Form.Control as="textarea" rows={2} value={alumnoData?.alu_tratamiento || "NO"} readOnly size="sm" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <div>
                                        <strong>Alergias <span style={{ fontSize: '0.8rem' }}>Cual/No</span></strong>
                                        <Form.Control type="text" value={alumnoData?.alu_alergia || "NO"} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Talla polera</strong>
                                        <Form.Control type="text" value={alumnoData?.polera || "S"} readOnly size="sm" />
                                    </div>
                                </Col>
                              
                                {giraData.gir_voucher_seguro && (
                                    <Col md={6}>
                                        <div>
                                            <strong>Nº Voucher Seguro Médico</strong>
                                            <Form.Control type="text" value={giraData.gir_voucher_seguro} readOnly size="sm" />
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* CONTACTO ADULTO RESPONSABLE */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#e3f2fd' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #bbdefb' }}>
                            <h6 style={{ margin: 0, color: '#1565c0', fontWeight: 'bold' }}>Contacto adulto responsable</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={2}>
                                    <div>
                                        <strong>RUT</strong>
                                        <Form.Control type="text" value={rut} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Nombres y apellidos</strong>
                                        <Form.Control type="text" value={`${usuario.nombre} ${usuario.apellido}`} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div>
                                        <strong>E-mail</strong>
                                        <Form.Control type="text" value={usuario.email || ""} readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div>
                                        <strong>Teléfono celular</strong>
                                        <Form.Control type="text" value={alumnoData?.celularcontacto || ""} placeholder="Sin información" readOnly size="sm" />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div>
                                        <strong>Parentesco</strong>
                                        <Form.Select size="sm" value={alumnoData?.idparentesco || ""} disabled>
                                            <option value="">Seleccionar</option>
                                            <option value="1">Abuelo(a)</option>
                                            <option value="2">Esposo(a)</option>
                                            <option value="3">Hermano(a)</option>
                                            <option value="4">Hijo(a)</option>
                                            <option value="5">Padre</option>
                                            <option value="6">Madre</option>
                                            <option value="7">Otro</option>
                                        </Form.Select>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <button type='button' onClick={handleOpenEditContactoModal} className='btn btn-warning btn-sm'>
                                        <i className='material-icons' style={{ marginRight: '5px' }}>edit</i>
                                        Editar Datos de Contacto
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* CONTACTO DE EMERGENCIA */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#f3e5f5' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #e1bee7' }}>
                            <h6 style={{ margin: 0, color: '#6a1b9a', fontWeight: 'bold' }}>Contacto de Emergencia</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            {contactosEmergencia && contactosEmergencia.length > 0 ? (
                                <div>
                                    <div style={{ marginBottom: '15px', padding: '12px', backgroundColor: '#faf0fb', borderRadius: '4px', borderLeft: '4px solid #6a1b9a' }}>
                                        <Row className="mb-2">
                                            <Col md={2}>
                                                <div>
                                                    <strong>RUT</strong>
                                                    <p>{contactosEmergencia[0].cem_rut}</p>
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div>
                                                    <strong>Nombres</strong>
                                                    <p>{contactosEmergencia[0].cem_nombres}</p>
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div>
                                                    <strong>Apellidos</strong>
                                                    <p>{contactosEmergencia[0].cem_apellidos}</p>
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div>
                                                    <strong>Email</strong>
                                                    <p style={{ wordBreak: 'break-word', fontSize: '0.9rem' }}>{contactosEmergencia[0].cem_email}</p>
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div>
                                                    <strong>Celular</strong>
                                                    <p>{contactosEmergencia[0].cem_celular}</p>
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div>
                                                    <strong>Parentesco</strong>
                                                    <p>{contactosEmergencia[0].cem_parentesco}</p>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                <button type='button' onClick={() => handleOpenEditContactoEmergenciaModal(contactosEmergencia[0])} className='btn btn-warning btn-sm'>
                                                    <i className='material-icons' style={{ fontSize: '16px', marginRight: '3px' }}>edit</i>
                                                    Editar
                                                </button>
                                                <button type='button' onClick={() => handleDeleteContactoEmergencia(contactosEmergencia[0].cem_id)} className='btn btn-danger btn-sm'>
                                                    <i className='material-icons' style={{ fontSize: '16px', marginRight: '3px' }}>delete</i>
                                                    Eliminar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ color: '#666', fontSize: '0.9rem', marginBottom: '15px' }}>
                                    <p>No hay contacto de emergencia registrado. Por favor, agrega uno.</p>
                                </div>
                            )}
                            {(!contactosEmergencia || contactosEmergencia.length === 0) && (
                                <Row>
                                    <Col md={12}>
                                        <button type='button' onClick={handleOpenContactoEmergenciaModal} className='btn btn-success btn-sm'>
                                            <i className='material-icons' style={{ marginRight: '5px' }}>add</i>
                                            Agregar Contacto de Emergencia
                                        </button>
                                    </Col>
                                </Row>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN DE CUOTAS Y PAGOS 
            <Row className="mb-4">
                <Col xl={12}>
                    <Row>
                        {floats.map((float, index) => (
                            <Col md={4} lg={4} key={index}>
                                <FloatCardComponent 
                                    variant={float.variant}
                                    digit={float.digit}
                                    title={float.title}
                                    icon={float.icon}
                                />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>*/}

            {/* COMPONENTE DE PAGOS Y DOCUMENTOS */}
            <Row className="mb-4">
                <Col xl={12}>
                    <MisPagosGiraComponent cuotas={cuotas} gira={giraData} docsGira={documentos} aluId={idAlumno} girId={idGira} /> 
                </Col>
            </Row>

            {/* SECCIÓN REEMBOLSO - MOSTRAR SOLICITUDES EXISTENTES */}
           

            {/* BOTÓN REEMBOLSO */}
            

            <Modal show={showEditModal} onHide={handleCloseEditModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Datos del Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nombres</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="alu_nombres"
                                        value={editData.alu_nombres || ""}
                                        onChange={handleEditChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Apellidos</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="alu_apellidos"
                                        value={editData.alu_apellidos || ""}
                                        onChange={handleEditChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>RUT</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="alu_rut_completo"
                                        value={rutInputValue}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setRutInputValue(value);
                                        }}
                                        onBlur={(e) => {
                                            // Validar y formatear cuando pierde el foco
                                            if (e.target.value.length >= 8) {
                                                checkRut(e.target);
                                                setRutInputValue(e.target.value);
                                            } else {
                                                // Si es muy corto, limpiar validación
                                                e.target.setCustomValidity('');
                                            }
                                        }}
                                        placeholder="12345678-9"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Fecha de Nacimiento</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="alu_fnacimiento"
                                        value={formatDateForInput(editData.alu_fnacimiento) || ""}
                                        onChange={(e) => {
                                            const formattedDate = formatDateForSave(e.target.value);
                                            setEditData({ ...editData, alu_fnacimiento: formattedDate });
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nacionalidad</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="alu_nacionalidad"
                                        value={editData.alu_nacionalidad || ""}
                                        onChange={handleEditChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Genero segun CI</Form.Label>
                            <Form.Select
            name="idgenero"
            value={editData.idgenero || ""}
            onChange={handleEditChange}
        >
            <option value="">Seleccionar</option>
            {generos?.map((g) => (
                <option key={g.id} value={g.id}>{g.nombre}</option>
            ))}
        </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Alergía</Form.Label>
                            <Form.Control
                                type="text"
                                name="alu_alergia"
                                value={editData.alu_alergia || ""}
                                onChange={handleEditChange}
                            />
                        </Form.Group>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo Alimentación</Form.Label>
                                      <Form.Control 
                                        type="text" 
                                        value={editData.alimientacion || "Sin restricción"}
                                        disabled
                                        readOnly
                                    />
                                   
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo Sangre</Form.Label>
                                    <Form.Select
                                            name="idsangre"
                                            value={editData.idsangre || ""}
                                            onChange={handleEditChange}
                                        >
                                            <option value="">Seleccionar</option>
                                            {tipoSangreData.map((s) => (
                                                <option key={s.id} value={s.id}>{s.nombre}</option>
                                            ))}
                                        </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                         <Form.Group className="mb-3">
                            <Form.Label>Enfermedad Pre-existente y/o Tipo de Alergia</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="alu_enfermedad"
                                value={editData.alu_enfermedad || ""}
                                onChange={handleEditChange}
                                placeholder="Ingrese detalles sobre enfermedades pre-existentes o alergias..."
                            />
                        </Form.Group>
                         <Form.Group className="mb-3">
                            <Form.Label>Tratamiento</Form.Label>
                            <Form.Control
                                 as="textarea"
                                 rows={2}
                                name="alu_tratamiento"
                                value={editData.alu_tratamiento || ""}
                                onChange={handleEditChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Talla Polera</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={tallaPoleraData.find(t => t.id === editData.idpolera)?.nombre || "Sin Información"}
                                disabled
                                readOnly
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                ¿Posee Nombre Social?
                                <i 
                                        className='material-icons' 
                                        style={{ fontSize: '18px', color: '#1976d2', cursor: 'pointer' }}
                                        title="Completar solo si el alumno es menor en transición de género"
                                    >
                                        info
                                    </i> Completar solo si el alumno/a es menor en transición de género
                            </Form.Label>
                            <Form.Select
                                name="alu_nombre_social_activo"
                                value={editData.alu_nombre_social_activo || "0"}
                                onChange={handleEditChange}
                            >
                                <option value="0">No</option>
                                <option value="1">Si</option>
                            </Form.Select>
                        </Form.Group>
                        {(editData.alu_nombre_social_activo === "1" || editData.alu_nombre_social_activo === 1) && (
                            <Form.Group className="mb-3">
                                <Form.Label>Nombre Social</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="alu_nombre_social"
                                    value={editData.alu_nombre_social || ""}
                                    onChange={handleEditChange}
                                    placeholder="Ingrese nombre social"
                                />
                            </Form.Group>
                        )}
                        <hr />
                        <h6 className="mb-3"><strong>Documento para Viaje</strong></h6>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Tipo de Documento *</strong></Form.Label>
                                    <Form.Select
                                        name="alu_tipo_documento"
                                        value={editData.alu_tipo_documento || ""}
                                        onChange={handleEditChange}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="Cedula de Identidad">Cédula de Identidad</option>
                                        <option value="Pasaporte">Pasaporte</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Fecha de Vencimiento del Documento *</strong></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="alu_fecha_vencimiento_documento"
                                        value={formatDateForInput(editData.alu_fecha_vencimiento_documento) || ""}
                                        onChange={handleEditChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveEdit}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showReembolsoModal} onHide={handleCloseReembolsoModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Solicitar Reembolso</Modal.Title>
                </Modal.Header>
                    <Modal.Body>
                        <p className="mb-3" style={{ color: '#666', fontSize: '0.9rem' }}>
                            <strong>Período elegible:</strong> Desde la firma del contrato hasta 72 horas antes de la salida del viaje. <br/>
                            <strong>Fecha límite de año:</strong> 30 de octubre del año del viaje.
                        </p>

                        {validacionPeriodo && validacionPeriodo.tieneValidacion && !validacionPeriodo.esValido && (
                            <div style={{ padding: '12px', backgroundColor: '#ffebee', borderRadius: '4px', marginBottom: '15px', borderLeft: '4px solid #f44336' }}>
                                <p style={{ margin: 0, color: '#d32f2f', fontSize: '0.9rem' }}>
                                    ⚠️ <strong>Advertencia:</strong> Esta gira está fuera del período elegible para reembolso. Tu solicitud será revisada pero podría ser rechazada.
                                </p>
                            </div>
                        )}

                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Tipo de Reembolso *</strong></Form.Label>
                                        <Form.Select 
                                            name="tipo"
                                            value={reembolsoData.tipo}
                                            onChange={handleReembolsoChange}
                                        >
                                            <option value="Fuerza Mayor">Fuerza Mayor</option>
                                            <option value="Seguro Viaje">Seguro Viaje</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Motivo *</strong></Form.Label>
                                        <Form.Select 
                                            name="motivo"
                                            value={reembolsoData.motivo}
                                            onChange={handleReembolsoChange}
                                        >
                                            <option value="">Seleccionar motivo...</option>
                                            <option value="Accidente">Accidente</option>
                                            <option value="Enfermedad">Enfermedad</option>
                                            <option value="Muerte Titular">Muerte del titular</option>
                                            <option value="Muerte Familiar Directo">Muerte de familiar directo (padre, madre, hermanos, cónyuge)</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Descripción de la Situación</strong></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="descripcion"
                                    value={reembolsoData.descripcion}
                                    onChange={handleReembolsoChange}
                                    placeholder="Proporciona detalles sobre la situación..."
                                />
                            </Form.Group>

                            <hr/>
                            <h6 className="mb-3"><strong>Datos Bancarios para Reembolso *</strong></h6>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Nombre del Banco *</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="bancoNombre"
                                            value={reembolsoData.bancoNombre}
                                            onChange={handleReembolsoChange}
                                            placeholder="ej: Banco State, BancoSantander"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Tipo de Cuenta *</strong></Form.Label>
                                        <Form.Select 
                                            name="tipoCuenta"
                                            value={reembolsoData.tipoCuenta}
                                            onChange={handleReembolsoChange}
                                        >
                                            <option value="Corriente">Corriente</option>
                                            <option value="Ahorro">Ahorro</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Número de Cuenta *</strong></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numeroCuenta"
                                    value={reembolsoData.numeroCuenta}
                                    onChange={handleReembolsoChange}
                                    placeholder="Número de cuenta bancaria"
                                />
                            </Form.Group>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>RUT Titular *</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="rutTitular"
                                            value={reembolsoData.rutTitular}
                                            onChange={handleReembolsoChange}
                                            placeholder="12345678-9"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Email *</strong></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="emailTitular"
                                            value={reembolsoData.emailTitular}
                                            onChange={handleReembolsoChange}
                                            placeholder="email@ejemplo.com"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Monto Solicitado (CLP) *</strong></Form.Label>
                                <Form.Control
                                    type="number"
                                    name="montoSolicitado"
                                    value={reembolsoData.montoSolicitado}
                                    onChange={handleReembolsoChange}
                                    placeholder="0"
                                    step="0.01"
                                    min="0"
                                />
                                <small style={{ color: '#666' }}>El monto será determinado por la empresa durante el proceso de validación.</small>
                            </Form.Group>

                            <div style={{ padding: '12px', backgroundColor: '#e3f2fd', borderRadius: '4px', fontSize: '0.85rem', color: '#1565c0' }}>
                                <p style={{ margin: 0 }}>
                                    <strong>Importante:</strong> Al enviar esta solicitud, autorizas a Cristour a utilizar los datos bancarios proporcionados para procesar el reembolso. Tu solicitud será revisada y recibirás notificación del estado.
                                </p>
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseReembolsoModal}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleSolicitarReembolso}>
                            Enviar Solicitud
                        </Button>
                    </Modal.Footer>
                </Modal>

            <Modal show={showEditContactoModal} onHide={handleCloseEditContactoModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Datos de Contacto</Modal.Title>
                </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label><strong>Teléfono Celular *</strong></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="usuCelular"
                                    value={editContactoData.usuCelular || ""}
                                    onChange={handleEditContactoChange}
                                    placeholder="Ingrese teléfono celular"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Parentesco *</strong></Form.Label>
                                <Form.Select
                                    name="idparentesco"
                                    value={editContactoData.idparentesco || ""}
                                    onChange={handleEditContactoChange}
                                >
                                    <option value="">Seleccionar</option>
                                    <option value="1">Abuelo(a)</option>
                                    <option value="2">Esposo(a)</option>
                                    <option value="3">Hermano(a)</option>
                                    <option value="4">Hijo(a)</option>
                                    <option value="5">Padre</option>
                                    <option value="6">Madre</option>
                                    <option value="7">Otro</option>
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseEditContactoModal}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleSaveEditContacto}>
                            Guardar Cambios
                        </Button>
                    </Modal.Footer>
                </Modal>

            {/* Modal para crear contacto de emergencia */}
            <Modal show={showContactoEmergenciaModal} onHide={handleCloseContactoEmergenciaModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Contacto de Emergencia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>RUT *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_rut"
                                        value={contactoEmergenciaData.cem_rut || ""}
                                        onChange={handleContactoEmergenciaChange}
                                        placeholder="12345678-9"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Parentesco *</strong></Form.Label>
                                    <Form.Select
                                        name="cem_parentesco"
                                        value={contactoEmergenciaData.cem_parentesco || ""}
                                        onChange={handleContactoEmergenciaChange}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="Abuelo(a)">Abuelo(a)</option>
                                        <option value="Esposo(a)">Esposo(a)</option>
                                        <option value="Hermano(a)">Hermano(a)</option>
                                        <option value="Hijo(a)">Hijo(a)</option>
                                        <option value="Padre">Padre</option>
                                        <option value="Madre">Madre</option>
                                        <option value="Otro">Otro</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Nombres *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_nombres"
                                        value={contactoEmergenciaData.cem_nombres || ""}
                                        onChange={handleContactoEmergenciaChange}
                                        placeholder="Nombres"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Apellidos *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_apellidos"
                                        value={contactoEmergenciaData.cem_apellidos || ""}
                                        onChange={handleContactoEmergenciaChange}
                                        placeholder="Apellidos"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Email *</strong></Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="cem_email"
                                        value={contactoEmergenciaData.cem_email || ""}
                                        onChange={handleContactoEmergenciaChange}
                                        placeholder="email@ejemplo.com"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Celular *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_celular"
                                        value={contactoEmergenciaData.cem_celular || ""}
                                        onChange={handleContactoEmergenciaChange}
                                        placeholder="9 1234567"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseContactoEmergenciaModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveContactoEmergencia}>
                        Agregar Contacto
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para editar contacto de emergencia */}
            <Modal show={showEditContactoEmergenciaModal} onHide={handleCloseEditContactoEmergenciaModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Contacto de Emergencia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>RUT *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_rut"
                                        value={editContactoEmergenciaData.cem_rut || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                        placeholder="12345678-9"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Parentesco *</strong></Form.Label>
                                    <Form.Select
                                        name="cem_parentesco"
                                        value={editContactoEmergenciaData.cem_parentesco || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="Abuelo(a)">Abuelo(a)</option>
                                        <option value="Esposo(a)">Esposo(a)</option>
                                        <option value="Hermano(a)">Hermano(a)</option>
                                        <option value="Hijo(a)">Hijo(a)</option>
                                        <option value="Padre">Padre</option>
                                        <option value="Madre">Madre</option>
                                        <option value="Otro">Otro</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Nombres *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_nombres"
                                        value={editContactoEmergenciaData.cem_nombres || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                        placeholder="Nombres"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Apellidos *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_apellidos"
                                        value={editContactoEmergenciaData.cem_apellidos || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                        placeholder="Apellidos"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Email *</strong></Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="cem_email"
                                        value={editContactoEmergenciaData.cem_email || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                        placeholder="email@ejemplo.com"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Celular *</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cem_celular"
                                        value={editContactoEmergenciaData.cem_celular || ""}
                                        onChange={handleEditContactoEmergenciaChange}
                                        placeholder="9 1234567"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditContactoEmergenciaModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveEditContactoEmergencia}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>

        </PageLayout>
    )
}